module.exports = __webpack_public_path__ + "img/night-mode.07e102eb.svg";